import { useEffect } from "react";
import { useAppStateProvider } from "../../contextProviders/AppStateProvider";

/**
 * Custom hook to check if the accounting feature is enabled
 * @param {Object} params - Hook parameters
 * @param {string} params.lang - Current language
 * @param {Object} params.history - React Router history object
 * @returns {Object} - { isEnabled: boolean, isLoading: boolean }
 */
function useAccountingFeatureFlag({ lang, history }) {
  const { appState } = useAppStateProvider();
  const isLoading = appState.isAccountingEnabled === null;
  const isEnabled = appState.isAccountingEnabled === true;

  useEffect(() => {
    // Redirect to home if feature is explicitly disabled (not loading, not enabled)
    if (appState.isAccountingEnabled === false) {
      history.push(`/${lang}/home`);
    }
  }, [appState.isAccountingEnabled, history, lang]);

  return { isEnabled, isLoading };
}

export default useAccountingFeatureFlag;
